import { render } from "./MonacoEditorModal.vue?vue&type=template&id=b9341d96&scoped=true&lang=pug"
import script from "./MonacoEditorModal.vue?vue&type=script&lang=js"
export * from "./MonacoEditorModal.vue?vue&type=script&lang=js"

import "./MonacoEditorModal.vue?vue&type=style&index=0&id=b9341d96&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9341d96"]])

export default __exports__